/**
 * @flow
 * @author: Chinmaya
 */

import * as React from 'react'
import Collapsible from './Collapsible'

import {
  EachItemContainer,
  SidebarContainer,
  MobileCollapseMenuLink,
  MobileCollapseTeamLink,
  MobileSideOptionsList,
  CloseIcon,
  CloseIconContainer,
  OfficesMenuItem
} from '../../HeaderMenuSection/styledComponents'
import {
  Dropdownlist,
  DropdownContainer,
  DropdownItems
} from './SideNavbarStyledComponents'
import ServicesDropdownList from '../../StakeHoldersDropdown'

import {
  goToBusiness,
  goToLearners,
  goToGameDevelopers,
  goToiBC,
  scrollToiBC,
  scrollToBusiness,
  scrollToLearners,
  scrollToGameDevelopers,
  scrollToOffices,
  goToOffices
} from '../../../utils/navigationUtils'

type Props = {}

class SideNavbar extends React.Component<Props> {
  goToTeam = e => {
    e.preventDefault()
    this.props.closeSideNavbar()
    window.location.href = '/team'
  }
  goToHome = e => {
    e.preventDefault()
    this.props.closeSideNavbar()
    window.location = '/'
  }

  goToOffices = e => {
    e.preventDefault()
    this.props.closeSideNavbar()
    scrollToOffices()
  }

  goToiBC = e => {
    e.preventDefault()
    this.props.closeSideNavbar()
    scrollToiBC()
  }
  goToContactUs = e => {
    e.preventDefault()
    this.props.closeSideNavbar()
    this.props.scrollToContactUs()
  }
  goToBusiness = e => {
    e.preventDefault()
    console.log('gotobusiness')
    this.props.closeSideNavbar()
    const { isHome } = this.props
    if (isHome) {
      scrollToBusiness()
    } else {
      goToBusiness()
    }
  }
  goToGameDevelopers = e => {
    e.preventDefault()
    this.props.closeSideNavbar()
    const { isHome } = this.props
    if (isHome) {
      scrollToGameDevelopers()
    } else {
      goToGameDevelopers()
    }
  }
  goToLearners = e => {
    e.preventDefault()
    this.props.closeSideNavbar()
    const { isHome } = this.props
    if (isHome) {
      scrollToLearners()
    } else {
      goToLearners()
    }
  }

  render() {
    const {
      isOpen,
      isHome,
      showTeam,
      showCareers,
      showiBCricket,
      showContactUs,
      showServices,
      showOffice,
      closeSideNavbar,
      scrollToIBC,
      scrollToOffices,
      scrollToContactUs
    } = this.props
    if (isOpen) {
      return (
        <SidebarContainer isOpen={isOpen}>
          <MobileSideOptionsList>
            <CloseIconContainer onClick={closeSideNavbar}>
              <CloseIcon> </CloseIcon>
            </CloseIconContainer>
            {!isHome ? (
              <MobileCollapseMenuLink href={'/'}>Home</MobileCollapseMenuLink>
            ) : null}
            {showiBCricket ? (
              isHome ? (
                <EachItemContainer onClick={closeSideNavbar}>
                  <MobileCollapseMenuLink onClick={this.goToiBC}>
                    iB Cricket
                  </MobileCollapseMenuLink>
                </EachItemContainer>
              ) : (
                <EachItemContainer onClick={closeSideNavbar}>
                  <MobileCollapseMenuLink href={'/?id=launch'}>
                    iB Cricket
                  </MobileCollapseMenuLink>
                </EachItemContainer>
              )
            ) : null}
            {showServices ? (
              <Collapsible trigger={'Services'}>
                <ServicesDropdownList
                  isHome={isHome}
                  renderDropdownList={Dropdownlist}
                  renderDropdownContainer={DropdownContainer}
                  renderDropdownItems={DropdownItems}
                  closeSideNavbar={closeSideNavbar}
                />
              </Collapsible>
            ) : null}
            {showTeam ? (
              <MobileCollapseMenuLink href={'/team'}>
                Team
              </MobileCollapseMenuLink>
            ) : null}
            <MobileCollapseMenuLink href={'/investor-relations'}>
            Investor Relations
              </MobileCollapseMenuLink>
              <MobileCollapseMenuLink href={'/careers'}>
               Careers
              </MobileCollapseMenuLink>
            {showOffice ? (
              isHome ? (
                <EachItemContainer onClick={closeSideNavbar}>
                  <MobileCollapseMenuLink onClick={this.goToOffices}>
                    Offices
                  </MobileCollapseMenuLink>
                </EachItemContainer>
              ) : (
                <EachItemContainer onClick={closeSideNavbar}>
                  <MobileCollapseMenuLink href={'/?id=our-offices'}>
                    Offices
                  </MobileCollapseMenuLink>
                </EachItemContainer>
              )
            ) : null}
            {showContactUs ? (
              <EachItemContainer onClick={closeSideNavbar}>
                <MobileCollapseMenuLink onClick={this.goToContactUs}>
                  Contact Us
                </MobileCollapseMenuLink>
              </EachItemContainer>
            ) : null}
          </MobileSideOptionsList>
        </SidebarContainer>
      )
    } else {
      return null
    }
  }
}

SideNavbar.defaultProps = {
  goToiBC: goToiBC,
  goToBusiness: goToBusiness,
  goToLearners: goToLearners,
  goToGameDevelopers: goToGameDevelopers,
  goToOffices: goToOffices
}

export default SideNavbar
